import { Button } from '@sravni/react-design-system/lib/Button';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Popover } from '@sravni/react-design-system/lib/Popover';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { useBoolean } from '@sravni/react-utils';

import { ContextMenuSvg } from '@src/components/icons/contextMenu';
import { Info } from '@src/components/icons/info';

import styles from './SponsoredMenu.module.scss';

export function SponsoredMenu({ company }: { company: string }) {
  const [visible, setVisible] = useBoolean(false);

  return (
    <Popover
      className={styles.popoverContainer}
      visible={visible}
      onClose={() => {
        setVisible.off();
      }}
      content={
        <Space direction="column" size={8}>
          <Text className={styles.text}>{company} </Text>
        </Space>
      }
    >
      <div className={styles.container}>
        <Icon icon={<ContextMenuSvg />} onClick={setVisible.on} />
      </div>
    </Popover>
  );
}
